// BridgeEngine Types.
// constants.
export enum Suits {
    Spades = 'spades',
    Hearts = 'hearts',
    Diamonds = 'diamonds',
    Clubs = 'clubs'
}
export const Suits1: string[] = ['s', 'h', 'd', 'c'];
export const SuitSymbols: string[] = ['♠', '♥', '♦', '♣'];
export const SuitColors: string[] = ['black', 'red', 'red', 'black'];

export const Ranks: string[] = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];
export const HonorCardsNoTens = ['A', 'K', 'Q', 'J'];

// TODO: Chat says avoid using enums, use types instead?? Except for the weird casting functions, it looks cleaner
// because all the string constants are here.
// export type DealSeat = 'north' | 'south' | 'east' | 'west';
// export type CardSeat = DealSeat | 'off';
export enum DealSeats {
    North = 'north',
    South = 'south',
    East = 'east',
    West = 'west',
}
// can't extend an enum, so keep this in sync with DealSeats.
export enum CardSeats {
    North = 'north',
    South = 'south',
    East = 'east',
    West = 'west',
    Off = 'off',
}
export const asDealSeats = (seat: CardSeats): DealSeats => {
    return seat as unknown as DealSeats;
}
export const asCardSeats = (seat: DealSeats): CardSeats => {
    return seat as unknown as CardSeats;
}
export const CardSeatsStringMap: { [key in CardSeats]: string } = {
    north: 'North',
    south: 'South',
    east: 'East',
    west: 'West',
    off: 'Off Table',
};
export const CardsSeatStringMap: { [key in CardSeats]: string } = {
    'north': 'North',
    'south': 'South',
    'east': 'East',
    'west': 'West',
    'off': 'Off Table',
};
export const TableSeats: DealSeats[] = [DealSeats.North, DealSeats.South, DealSeats.East, DealSeats.West];
export const AuctionSeats: DealSeats[] = [DealSeats.West, DealSeats.North, DealSeats.East, DealSeats.South];
